var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:_vm.$style.container},_vm._l((8),function(i){return _c('PChatMessage',{key:i,attrs:{"even":i % 2 === 0}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }